import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
}: Theme) => ({
  actions: {
    display: 'flex',
    gap: '0.75rem',
  },
  resetButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    [breakpoints.down('sm')]: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
  },
  paper: {
    paddingTop: '2rem',
    [breakpoints.up('sm')]: {
      paddingTop: '3rem',
      paddingBottom: '3rem',
    },
  },
}));
